'use strict';

/**
 * Display the returned message.
 * @param {string} data - data returned from the server's ajax call
 * @param {Object} button - button that was clicked for contact us sign-up
 */
function displayMessage(data, button) {
    $.spinner().stop();
    var status;
    if (data.success) {
        status = 'alert-success';
    } else {
        status = 'alert-danger';
    }

    if ($('.quote-signup-message').length === 0) {
        $('body').append(
            '<div class="quote-signup-message"></div>'
        );
    }
    $('.quote-signup-message')
        .append('<div class="quote-signup-alert text-center ' + status + '" role="alert">' + data.msg + '</div>');

    setTimeout(function () {
        $('.quote-signup-message').remove();
        button.removeAttr('disabled');
    }, 3000);
}


module.exports = {
    submitQuote: function () {
        $('textarea').keyup(function () {
            var $errorDiv = $(this).next('.invalid-feedback');
            if ($(this).val().length <= 0) {
                $(this).addClass('is-invalid');
                $errorDiv.show();
            } else {
                $errorDiv.hide();
                $(this).removeClass('is-invalid');
            }
        });

        $('form.quote').submit(function (e) {
            e.preventDefault();

            var form = $(this);
            var button = $('.btn-send-quote');
            var url = form.attr('action');

            $.spinner().start();
            button.attr('disabled', true);
            if (grecaptcha) {
                grecaptcha.ready(function () {
                    grecaptcha.execute(window.app.preferences.reCaptchaSiteKey, { action: 'submit' }).then(function (token) {
                        var payload = form.serialize() + '&reCaptchaToken=' + token;
                        $.ajax({
                            url: url,
                            type: 'post',
                            dataType: 'json',
                            data: payload,
                            success: function (data) {
                                $.spinner().stop();
                                if (data.success) {
                                    $('.quote').trigger('reset');
                                    window.location.href = data.redirectUrl;
                                } else {
                                    displayMessage(data, button);
                                }
                            },
                            error: function (err) {
                                displayMessage(err, button);
                                $.spinner().stop();
                            }
                        });
                    });
                });
            }
        });
    }
};
